<template>
  <div id="print-report">
    <!-- Print Only -->
    <HeaderPrint />
    <!-- Print Only -->
    <v-card
      :style="
        $vuetify.breakpoint.smAndDown
          ? 'margin: auto; margin-top: 24px;'
          : 'width: 100%; margin: auto; margin-top: 0px;'
      "
    >
    <div class="pa-2 d-print-none">
      <v-row no-gutters class="d-flex align-center">
        <v-col cols="6" lg="9">
            <v-btn
              small
              class="white black--text d-print-none"
              @click="$printReport()"
            >
              <v-icon small left>mdi-printer</v-icon>
              {{ $t("print") }}
            </v-btn>
        </v-col>

        <v-col cols="6" v-if="typeList" class="d-md-none">
          <div class="text-right">
            <v-btn-toggle
                v-model="toggle"
                mandatory
                dense
              >
                <v-btn>
                  <v-icon>mdi-view-list</v-icon>
                </v-btn>
                <v-btn>
                  <v-icon>mdi-view-grid</v-icon>
                </v-btn>
              </v-btn-toggle>
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="12"
          lg="3"
          md="4"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
        >
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
            dense
            solo-inverted
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <!-- mobile datatable -->
    <v-data-table
      v-if="typeList"
      :headers="headers"
      :items="affiliatesCpa"
      item-key="affiliate_id"
      :search="search"
      :mobile-breakpoint="breakpoint"
      :loading="loading"
      :single-expand="true"
      show-expand
      :expanded.sync="expanded"
      :loading-text="$t('loadingData')"
      :no-data-text="$t('autoCompleteNoData')"
      :footer-props="{
        'items-per-page-text': $t('rowsPerPage'),
        'items-per-page-options': [5, 10, 15],
      }"
    >
      <template v-slot:item.affiliate_name="{ item }">
        <a
          class="blue--text"
          @click="
            $profile.showProfileDrawer(
              item.affiliate_id,
              'localManager/agents/getAgent'
            )
          "
        >
          <v-icon color="blue" small>mdi-account-multiple</v-icon>
          {{ item.affiliate_name }}
        </a>
      </template>

      <template v-slot:item.cpa_type="{ item }">
        <div class="d-flex align-center">
          <div>
            {{ handleCpaType(item.cpa_type) }}
          </div>
        </div>
      </template>

      <template v-slot:item.cpa_value="{ item }">
        <div class="d-flex">
          <div>
            {{ item.cpa_value }}
          </div>
        </div>
      </template>

      <template v-slot:item.commission="{ item }">
        <div class="d-flex">
          <div class="red--text">
            {{ $t("labelCurrency") }} {{ item.commission }}
          </div>
        </div>
      </template>
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-btn
          @click="[expand(true), getCpaDetails(item.affiliate_id)]"
          v-if="!isExpanded"
          class="info"
          light
          small
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          @click="expand(false)"
          v-if="isExpanded"
          class="white"
          light
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length" class="pa-3 grey lighten-1">
          <div>
            <v-data-table
              :headers="detailsHeaders"
              :items="cpaDetails"
              :loading="loadingDetails"
              :loading-text="$t('loadingData')"
              :no-data-text="$t('autoCompleteNoData')"
              :footer-props="{
                'items-per-page-text': $t('rowsPerPage'),
                'items-per-page-options': [5, 10, 15],
              }"
              mobile-breakpoint="360"
            >
              <template v-slot:item="{ item }">
                <tr
                  v-for="(detail, i) in item"
                  :key="i"
                  style="width: 100%"
                >
                  <td>
                    <v-btn
                      @click="$copy(detail.player_id)"
                      x-small
                    >
                      {{
                        detail.player_id
                      }}
                    </v-btn>
                  </td>
                  <td>
                    <div class="red--text">
                      {{$t("labelCurrency")}} {{ Number(detail.commissions * -1).toFixed(2) }}
                    </div>
                  </td>
                  <td class="green--text">
                    {{$t("labelCurrency")}} {{ detail.player_first_deposit }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </td>
      </template>
    </v-data-table>

    <!-- desktop datatable -->
    <v-data-table
      v-else
      :headers="headers"
      :items="affiliatesCpa"
      item-key="affiliate_id"
      :search="search"
      :loading="loading"
      :single-expand="true"
      show-expand
      :expanded.sync="expanded"
      :loading-text="$t('loadingData')"
      :no-data-text="$t('autoCompleteNoData')"
      :footer-props="{
        'items-per-page-text': $t('rowsPerPage'),
        'items-per-page-options': [5, 10, 15],
        // [5, 10, 15, { 'text': $t('all'),'value': -1 }],
      }"
    >
      <template v-slot:item.affiliate_name="{ item }">
        <a
          class="blue--text"
          @click="
            $profile.showProfileDrawer(
              item.affiliate_id,
              'localManager/agents/getAgent'
            )
          "
        >
          <v-icon color="blue" small>mdi-account-multiple</v-icon>
          {{ item.affiliate_name }}
        </a>
      </template>

      <template v-slot:item.cpa_type="{ item }">
        <div class="d-flex align-center">
          <div>
            {{ handleCpaType(item.cpa_type) }}
          </div>
        </div>
      </template>

      <template v-slot:item.cpa_value="{ item }">
        <div class="d-flex">
          <div>
            {{ item.cpa_value }}
          </div>
        </div>
      </template>

      <template v-slot:item.commission="{ item }">
        <div class="d-flex">
          <div class="red--text">
            {{ $t("labelCurrency") }} {{ item.commission }}
          </div>
        </div>
      </template>
      <!-- CPA detalhes Button -->
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-btn
          @click="[expand(true), getCpaDetails(item.affiliate_id)]"
          v-if="!isExpanded"
          class="info"
          light
          small
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>

        <v-btn
          @click="expand(false)"
          v-if="isExpanded"
          class="white"
          light
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <!-- CPA Detalhes Table -->
      <template v-slot:expanded-item="{ headers }">
        <td :colspan="headers.length" class="pa-3 grey lighten-1">
          <div>
            <v-data-table
              :headers="detailsHeaders"
              :items="cpaDetails"
              :loading="loadingDetails"
              mobile-breakpoint="360"
              :no-data-text="$t('loadingData')"
              :footer-props="{
                'items-per-page-text': $t('rowsPerPage'),
                'items-per-page-options': [5, 10, 15],
              }"
            >
              <template v-slot:item="{ item }">
                <tr
                  v-for="(detail, i) in item"
                  :key="i"
                  style="width: 100%"
                >
                  <td>
                    <v-btn
                      @click="$copy(detail.player_id)"
                      x-small
                    >
                      {{
                        detail.player_id
                      }}
                    </v-btn>
                  </td>
                  <td>
                    <div class="red--text">
                      {{$t("labelCurrency")}} {{ Number(detail.commissions * -1).toFixed(2) }}
                    </div>
                  </td>
                  <td class="green--text">
                    {{$t("labelCurrency")}} {{ detail.player_first_deposit }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </td>
      </template>
    </v-data-table>
    </v-card>

    <!-- Resume -->
    <div class="mt-4" v-if="showResume">
      <v-row>
        <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-card class="pa-3">
            <div class="subtitle-1 mb-2">
              {{ $t("resumeSummary") }}
              <v-icon
                class="float-right mr-3 d-print-none"
                @click="$copy(resumePrint)"
              >
                mdi-content-copy
              </v-icon>
              <div class="caption">{{ $store.state.rangeUI }}</div>
            </div>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>{{ $t("affiliates") }}</td>
                    <td
                      class="text-right"
                    >
                      <b>{{ resume.affiliates }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("commissions") }} Total</td>
                    <td class="text-right red--text">
                      <b>{{ $t("labelCurrency") }} {{ resume.commissions }}</b>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "affiliate-cpa",
  components: {
    HeaderPrint,
  },
  data: (self) => ({
    toggle: 0,
    breakpoint: "0",
    search: "",
    loading: false,
    loadingDetails: false,
    expanded: [],
    showResume: false,
    resumePrint: "",
    resume: "",
    typeList: false,
    headers: [
      {
        text: self.$t('affiliate'),
        value: "affiliate_name",
        align: "no-wrap"
      },
      {
        text: self.$t('login'),
        value: "affiliate_login",
        align: "no-wrap"
      },
      {
        text: self.$t('cpaType'),
        value: "cpa_type",
        align: "no-wrap"
      },
      {
        text: self.$t('cpaValue'),
        value: "cpa_value",
        align: "no-wrap"
      },
      {
        text: self.$t('commission'),
        value: "commission",
        align: "no-wrap"
      },
      {
        text: self.$t('details'),
        value: "data-table-expand",
        align: "no-wrap",
      },
    ],
    affiliatesCpa: [],
    detailsHeaders: [
      {
        text: self.$t('playerId'),
        value: "player_id"
      },
      {
        text: self.$t('commission'),
        value: "commissions"
      },
      {
        text: self.$t('firstDeposit'),
        value: "player_first_deposit"
      },
    ],
    cpaDetails: [],
  }),

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    affiliateId() {
      return this.$store.state.filters.autocompleteAgents.id;
    },

    hasInvoice() {
      return this.$store.state.filters.hasInvoice.value;
    },

    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },

    currentBreakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },

  watch: {
    saveFilters(val) {
      val && this.getAffiliateCpa()
    },

    toggle(val) {
      val === 0 ? this.breakpoint = 0 : this.breakpoint = 'xs'
    },
  },

  created() {
    this.currentBreakpoint === "xs" && (this.typeList = true);
  },

  methods: {
    getAffiliateCpa() {
      this.affiliatesCpa = [];
      const body = {
        ...this.rangeDate,
        type: "grouped", // grouped, list
        invoice: this.hasInvoice,
        ...(
          this.exportDoc ? {
            export: this.exportDoc,
          } :
          {}
        ),
        ...(
          this.affiliateId ? {
            affiliate_id: this.affiliateId
          } :
          {}
        )
      };

      if (this.exportDoc) {
        const extension = this.exportDoc;
        this.$request.exportDoc(
          "/localManager/financial/affiliatesCpa",
          body,
          extension,
          this.rangeDate
        )
        return
      }

      this.loading = true;

      this.$axios.post("/localManager/financial/affiliatesCpa", this.$formdata(body))
      .then((resp) => {
        this.affiliatesCpa = resp.data.dados
        this.affiliatesCpa.forEach((item) => {
          item.commission = Number(item.commission * -1).toFixed(2)
        })
        this.buildResume(this.affiliatesCpa)
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      });
    },
    
    getCpaDetails(idAffiliate) {
      this.cpaDetails = []
      this.loadingDetails = true;
      const body = {
        ...this.rangeDate,
        type: "list",
        affiliate_id: idAffiliate,
      }
      this.$axios.post("/localManager/financial/affiliatesCpa", this.$formdata(body))
      .then((resp) => {
        this.cpaDetails = resp.data.dados.map(details => details.cpa_details);
      })
      .catch(() => {})
      .finally(this.loadingDetails = false)
    },

    buildResume(affiliatesCpa) {
      if (!affiliatesCpa) return;

      let resume = {
        commissions: {},
        affiliates: {},
      };

      resume.affiliates = affiliatesCpa.map(item => item.affiliate_id)
      resume.commissions = affiliatesCpa.map(item => Number(item.commission))

      const reducer = (accumulator, currentValue) => accumulator + currentValue;
      resume.commissions = Number(
          resume.commissions.reduce(reducer)
        ).toFixed(2);
      resume.affiliates = resume.affiliates.length

      this.resume = resume;
      this.showResume = true;
      this.resumeExcelCopy();
    },

    resumeExcelCopy() {
      // Create String with table to Copy on Btn
      this.resumePrint = `<table>
        <tr>${this.resume.affiliates.toString().replace(".", ",")}</tr>
        <tr>${this.resume.commissions.toString().replace(".", ",")}</tr>
     </table>`;
    },

    handleCpaType(type) {
      if (type == 0) {
        return this.$t('disabled');
      }
      if (type == 1) {
        return `${this.$t('fixedCommission')} (${this.$t('labelCurrency')})`
      }
      if (type == 2) {
        return `${this.$t('percent')} (%)`
      }
    },
  }
}
</script>